// extracted by mini-css-extract-plugin
export default {"levelBox":"CompetenceLevelsInput_levelBox__TQHfe","levelsBox":"CompetenceLevelsInput_levelsBox__UurZQ"};